var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('s-wrapper',{attrs:{"variant":_vm.buttonVariant,"size":_vm.buttonSize,"block":_vm.block,"outline":_vm.outline,"pill":_vm.pill}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }